import shopAuthorizeView from "./ShopAuthorizeView";

export default shopAuthorizeView;
